/* eslint-disable no-param-reassign */
import type { Layer } from '../core/layer';
import { layer as line } from './preset/line/line';
import { layer as positiveAndNegativeDoubleIndicatorComparisonLine } from './preset/line/positiveAndNegativeDoubleIndicatorComparisonLine';
import { dynamicLine } from './preset/line/dynamicLine';
import { dynamicRankingLine } from './preset/line/dynamicRankingLine';
import { layer as bar } from './preset/bar/bar';
import { layer as groupedStackedBar } from './preset/bar/groupedStackedBar';
import { layer as positiveAndNegativeDoubleIndicatorSumBar } from './preset/bar/positiveAndNegativeDoubleIndicatorSumBar';
import { layer as pie } from './preset/pie/pie';
import { layer as doublePie } from './preset/pie/doublePie';
import { layer as scatter } from './preset/scatter/scatter';
import { bandedIntervalTrendLine } from './preset/line/bandedIntervalTrendLine';
import { multiIndicatorRingGauge } from './preset/gauge/multiIndicatorRingGauge';
import { gauge } from './preset/gauge/gauge';
import { radar } from './preset/radar/radar';
import { dvRadar } from './preset/radar/dvRadar';
import { treeMap } from './preset/treeMap/treeMap';
import { waterfall } from './preset/bar/waterfall';
import { layer as summaryText } from './preset/text/summaryText';
import { dynamicBeeSwarm } from './preset/scatter/dynamicBeeSwarm';
import { layer as bar3D } from './preset/bar/bar3D';
import { layer as scatter3D } from './preset/scatter/scatter3D';
import { dynamicBubble } from './preset/scatter/dynamicBubble';
import { dynamicRankingHorizontalBar } from './preset/bar/dynamicRankingHorizontalBar';
import { dynamicRankingTwoWayHorizontalBar } from './preset/bar/dynamicRankingTwoWayHorizontalBar';
import { dynamicVoronoi } from './preset/other/dynamicVoronoi';
import { polarBar } from './preset/bar/polarBar';
import { layer as timeLine } from './preset/text/timeLine';
import { layer as text } from './preset/text/text';
import { layer as multiTable } from './preset/text/multiTable';
import { layer as wordCloud } from './preset/other/wordCloud';
import { dynamicPie } from './preset/pie/dynamicPie';
import { layer as rankingLine } from './preset/line/rankingLine';
import { layer as dynamicTreeMap } from './preset/treeMap/dynamicTreeMap';
import { layer as rankingHorizontalBar } from './preset/bar/rankingHorizontalBar';
import { layer as rankingTwoWayHorizontalBar } from './preset/bar/rankingTwoWayHorizontalBar';
import { layer as drillableTreemap } from './preset/treeMap/drillableTreemap';
import { layer as markerLine } from './preset/line/markerLine';
import { dynamicSankey } from './preset/other/dynamicSankey';
import { barDistribution } from './preset/bar/barDistribution';
import { tree } from './preset/tree/tree';
import { chainChangeBar } from './preset/bar/chainChangeBar';
import { shadowBar } from './preset/bar/shadowBar';
import { stackBoardBar } from './preset/bar/stackBoardBar';
import { contrastDoubleBar } from './preset/bar/contrastDoubleBar';
import { layer as funnel } from './preset/funnel/funnel';
import { layer as hierarchicalLine } from './preset/line/hierarchicalLine';
import { layer as differenceBarLine } from './preset/bar/differenceBarLine';

export const layersGroup = [
  {
    text: 'line',
    layers: [
      line,
      bandedIntervalTrendLine,
      positiveAndNegativeDoubleIndicatorComparisonLine,
      dynamicLine,
      rankingLine,
      dynamicRankingLine,
      markerLine,
      hierarchicalLine
    ]
  },
  {
    text: 'bar',
    layers: [
      bar,
      // TODO bar
      // stackedBar,
      // TODO bar
      // groupedBar,
      // TODO bar
      // proportionalBar,
      // TODO bar
      polarBar,
      groupedStackedBar,
      waterfall,
      // doubleIndicatorBarAndLine
      barDistribution,
      chainChangeBar,
      shadowBar,
      stackBoardBar,
      contrastDoubleBar
    ]
  },
  {
    text: 'horizontalBar',
    layers: [
      // groupedHorizontalBar,
      // stackedHorizontalBar,
      positiveAndNegativeDoubleIndicatorSumBar,
      dynamicRankingTwoWayHorizontalBar,
      rankingHorizontalBar,
      dynamicRankingHorizontalBar,
      rankingTwoWayHorizontalBar
    ]
  },
  {
    text: 'pie',
    layers: [pie, doublePie, multiIndicatorRingGauge, dynamicVoronoi, dynamicPie]
  },
  {
    text: 'scatter',
    layers: [scatter, dynamicBeeSwarm, dynamicBubble]
  },
  {
    text: 'tree',
    layers: [tree]
  },
  {
    text: '3D',
    layers: [bar3D, scatter3D]
  },
  {
    text: 'text',
    layers: [summaryText, timeLine, text, multiTable]
  },
  {
    text: 'other',
    layers: [
      gauge,
      radar,
      dvRadar,
      treeMap,
      wordCloud,
      dynamicTreeMap,
      drillableTreemap,
      dynamicSankey,
      funnel,
      differenceBarLine
    ]
  }
] as const;

export const layers = layersGroup.map(item => item.layers).flat(Infinity) as Layer[];
